module.exports = __webpack_public_path__ + "static/home-pricing-image-c41c6cdc38627d9d237c9ead37d4ff83.svg";